module.exports = "<div class=\"row\">\n  <div class=\"col-sm-12 col-md-12 col-lg-12\">\n    <summary-view heading=\"Geography Summary\" card-colour=\"blue\" icon=\"public\" get-data=\"$ctrl.getGeographyData()\">\n    </summary-view>\n    <summary-view heading=\"Sector Summary\" card-colour=\"blue\" icon=\"domain\" get-data=\"$ctrl.getSectorData()\">\n    </summary-view>\n  </div>\n</div>\n";


//////////////////
// WEBPACK FOOTER
// ./src/app/portfolio/geographyAndSector/overview.html
// module id = 1263
// module chunks = 0